var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { useQuery } from "react-query";
import { ReservationStatus } from "../../../models/reservation/reservation.model";
import { ReservationService } from "../../../services/reservation/reservation.service";
import { useResources } from "../resources/useResources";
import { useService } from "../services/useServices";
import { useResourceCategories } from "../resources/useAllResourceCategories";
import { endOfDay, endOfWeek, startOfDay, startOfWeek } from "../../date.util";
export var useReservations = function (ids) {
    var idsSorted = __spreadArray([], ids, true).sort();
    var query = useQuery(['reservations', idsSorted], function () { return __awaiter(void 0, void 0, void 0, function () {
        var response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!idsSorted.length)
                        return [2 /*return*/, []];
                    return [4 /*yield*/, ReservationService.getAllReservations({
                            id: idsSorted,
                            limit: {
                                offset: 0,
                                limit: 1000,
                                sort: [{ field: "id", direction: "DESC" }]
                            }
                        })];
                case 1:
                    response = _a.sent();
                    return [2 /*return*/, response.content || []];
            }
        });
    }); });
    return query;
};
export var useReservationsCalendarSearch = function (searchQuery, fromDate, toDate, sectorId, sectorIdResourceCriteria, selectedStatuses, selectedResources) {
    // We need to refetch when fromDate changes as well
    var query = useQuery(['reservations', searchQuery, selectedStatuses, selectedResources, fromDate], function () { return __awaiter(void 0, void 0, void 0, function () {
        var reservations, response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!(searchQuery && searchQuery.trim().length > 0)) return [3 /*break*/, 2];
                    return [4 /*yield*/, ReservationService.searchReservationsByProfile({
                            query: searchQuery,
                            // Only send the window when both bounds exist (avoids sending an
                            // overlaps object with an undefined member, which 400s on the API).
                            overlaps: (fromDate && toDate) ? { start: fromDate, end: toDate } : undefined,
                            sectorIds: sectorId ? [sectorId] : undefined,
                            resourceIds: selectedResources ? selectedResources === null || selectedResources === void 0 ? void 0 : selectedResources.map(function (r) { return r.id; }) : undefined,
                            statuses: selectedStatuses,
                            limit: 50
                        })];
                case 1:
                    reservations = _a.sent();
                    return [2 /*return*/, reservations || []];
                case 2: return [4 /*yield*/, ReservationService.getAllReservations({
                        query: undefined,
                        overlaps: {
                            start: fromDate,
                            end: toDate
                        },
                        limit: {
                            offset: 0,
                            // CAUTION - limit should be higher depending on the seed data pool, for demo purposes we leave it like this
                            limit: 50,
                            sort: [{ field: "id", direction: "DESC" }]
                        },
                        sectorIds: [sectorId],
                        accommodationSectorId: [sectorIdResourceCriteria],
                        status: selectedStatuses,
                        resourceIds: selectedResources ? selectedResources === null || selectedResources === void 0 ? void 0 : selectedResources.map(function (r) { return r.id; }) : undefined
                    })];
                case 3:
                    response = _a.sent();
                    return [2 /*return*/, response.content || []];
            }
        });
    }); }, {
        // Keep the current results on screen while the next keystroke refetches, so the
        // list updates smoothly instead of flashing empty — mirrors the floorplan canvas.
        keepPreviousData: true
    });
    return { searchedReservationsData: query.data || [], isLoading: query.isLoading, refetch: query.refetch };
};
export var useAllReservations = function (ids) {
    var query = useReservations(ids);
    return query.data || [];
};
export var useSingleFullReservation = function (id) {
    var _a;
    var query = useReservations(id ? [id] : []);
    var reservation = (_a = query.data) === null || _a === void 0 ? void 0 : _a[0];
    var resources = useResources((reservation === null || reservation === void 0 ? void 0 : reservation.resourceIds) || []);
    var services = useService(reservation === null || reservation === void 0 ? void 0 : reservation.serviceId);
    var resourceCategories = useResourceCategories(resources.map(function (resource) { return (resource.categoryIds || []); }).flat() || []);
    return {
        reservation: reservation,
        resources: resources,
        service: services,
        resourceCategories: resourceCategories,
        isLoading: query.isLoading
    };
};
export var useReservationFilterOptions = function () {
    return useQuery('reservationFilterOptions', ReservationService.getFilterOptions, {
        // 10 minutes
        staleTime: 10 * 60 * 1000
    });
};
export var useSectorReservations = function (queryKeys, sectorId, dateRangeFrom, dateRangeTo, statuses, resourceIds, queryOptions) {
    var query = useQuery(queryKeys, function () { return __awaiter(void 0, void 0, void 0, function () {
        var offset, limit, hasMore, allReservations, reservationsPage;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    offset = 0;
                    limit = 1000;
                    hasMore = true;
                    allReservations = [];
                    _a.label = 1;
                case 1: return [4 /*yield*/, ReservationService.getAllReservations({
                        sectorIds: [sectorId],
                        status: statuses,
                        overlaps: {
                            start: dateRangeFrom,
                            end: dateRangeTo
                        },
                        limit: {
                            offset: offset,
                            limit: limit,
                            sort: [{ field: "id", direction: "DESC" }]
                        },
                        resourceIds: resourceIds
                    })];
                case 2:
                    reservationsPage = _a.sent();
                    allReservations.push.apply(allReservations, (reservationsPage.content || []));
                    hasMore = !reservationsPage.last;
                    // Previous bug - Offset wasn't incremented
                    offset += limit;
                    _a.label = 3;
                case 3:
                    if (hasMore) return [3 /*break*/, 1];
                    _a.label = 4;
                case 4: return [2 /*return*/, allReservations || []];
            }
        });
    }); }, {
        keepPreviousData: queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.keepPreviousData,
    });
    return query;
};
export var useResourceReservations = function (resourceIds, dateRangeFrom, dateRangeTo, sectorId, statuses) {
    // We need to refetch when fromDate changes as well
    return useQuery(['resourceReservations', resourceIds], function () { return __awaiter(void 0, void 0, void 0, function () {
        var response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, ReservationService.getAllReservations({
                        // Setting gentle overlap to allow creating blocks that start or end exactly when another reservation ends or starts
                        overlapsGentle: {
                            start: dateRangeFrom,
                            end: dateRangeTo
                        },
                        status: statuses,
                        limit: {
                            offset: 0,
                            // CAUTION - limit should be higher depending on the seed data pool, for demo purposes we leave it like this
                            limit: 50,
                            sort: [{ field: "id", direction: "DESC" }]
                        },
                        resourceIds: resourceIds,
                        sectorIds: sectorId ? [sectorId] : undefined
                    })];
                case 1:
                    response = _a.sent();
                    return [2 /*return*/, response.content || []];
            }
        });
    }); });
};
export var useServiceReservations = function (serviceIds, timelineSpan, start, end, agendaId, queryOptions) {
    var startDate = timelineSpan === "week" ? startOfWeek(start) : startOfDay(start);
    var endDate = timelineSpan === "week" ? endOfWeek(end) : endOfDay(end);
    // We need to refetch when fromDate changes as well
    return useQuery(['serviceReservations', serviceIds, timelineSpan, startDate, endDate, agendaId], function () { return __awaiter(void 0, void 0, void 0, function () {
        var response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, ReservationService.getAllReservations({
                        serviceId: __spreadArray([], serviceIds, true),
                        limit: {
                            offset: 0,
                            // CAUTION - limit should be higher depending on the seed data pool, for demo purposes we leave it like this
                            limit: 500,
                            sort: [{ field: "id", direction: "DESC" }]
                        },
                        overlaps: { start: startDate, end: endDate },
                        status: [ReservationStatus.CONFIRMED, ReservationStatus.PENDING, ReservationStatus.ACTIVE]
                    })];
                case 1:
                    response = _a.sent();
                    return [2 /*return*/, response.content || []];
            }
        });
    }); }, {
        enabled: serviceIds.length > 0,
        keepPreviousData: queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.keepPreviousData,
    });
};
